import "./App.css";
import { Suspense, lazy } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import ThemeProvider from "./utils/theme";
import LayoutWrapper from "./components/layout/LayoutWrapper";
import "./i18n";

// Update imports - organize in Transactions folder
const Dashboard = lazy(() => import("./pages/Dashboard"));
const PrintRequests = lazy(() => import("./pages/PrintRequests"));
const Services = lazy(() => import("./pages/Services"));
const Configurations = lazy(() => import("./pages/Configurations"));
const Login = lazy(() => import("./pages/Login"));
const HistoryRequest = lazy(() => import("./pages/HistoryRequest"));
const MorePage = lazy(() => import("./pages/MorePage"));

// Transactions-related pages
const Transactions = lazy(() => import("./pages/Transactions/Transactions"));
const AllTransactions = lazy(() => import("./pages/Transactions/AllTransactions"));
const TransactionReport = lazy(() => import("./pages/Transactions/TransactionReport"));
const queryClient = new QueryClient();

// Update routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutWrapper />,
    children: [
      { path: "/", element: <Dashboard /> },
      { path: "/requests", element: <PrintRequests /> },
      { path: "/services", element: <Services /> },
      { path: "/configuration", element: <Configurations /> },
      { path: "/history", element: <HistoryRequest /> },
      { path: "/more", element: <MorePage /> },
      { path: "/transactions", element: <Transactions /> },
      { path: "/transactions-detail", element: <AllTransactions /> }, // New route

      // In App.jsx or routes configuration
      {
        path: "/transactions",
        element: <Transactions />,
      },
      {
        path: "/all-transactions",
        element: <AllTransactions />,
      },
      {
        path: "/transaction-report",
        element: <TransactionReport />, // This component needs to exist!
      }

    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);


function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<div>Loading...</div>}>
          <RouterProvider router={router} />
        </Suspense>

        {/* react-hot-toast toaster */}
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            success: {
              style: {
                background: "#10b981", // Green-500
                color: "#fff",
                border: "1px solid #059669", // Green-600
              },
              iconTheme: {
                primary: "#fff",
                secondary: "#10b981",
              },
            },
            error: {
              style: {
                background: "#ef4444", // Red-500
                color: "#fff",
                border: "1px solid #dc2626", // Red-600
              },
              iconTheme: {
                primary: "#fff",
                secondary: "#ef4444",
              },
            },
          }}
        />
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
